export default __webpack_public_path__ + "static/media/legal-team-prosecutor2.a7f67fbc.png";